/* eslint-disable react/no-unknown-property */

import Head from "next/head";
import { useState } from "react";

import { useIsomorphicLayoutEffect } from "../hooks/use-isomorphic-layout-effect";
import type { LookbookProps } from "../lookbook";
import { Size } from "../providers/Size";
import { CheckoutViewRouter } from "./CheckoutViewRouter";
import { LookbookViewRouter } from "./LookbookViewRouter";

export type LookbookViewProps = LookbookProps;

export function LookbookView(props: LookbookViewProps) {
  const { meta, checkout } = props;

  const [playing, setPlaying] = useState(true);

  useIsomorphicLayoutEffect(() => {
    const existingLinkTag = document.querySelector(
      `link[href="${props.font.stylesheetUrl}"]`,
    );
    if (!existingLinkTag) {
      const linkTag = document.createElement("link");
      linkTag.rel = "stylesheet";
      linkTag.href = props.font.stylesheetUrl;
      document.head.appendChild(linkTag);
    }
  }, [props.font.stylesheetUrl]);

  return (
    <Size>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta property="og:url" content={meta.canonicalUrl} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        {meta.previewImageUrl ? (
          <>
            <meta property="og:image" content={meta.previewImageUrl} />
            <meta property="og:image:width" content="800" />
            <meta property="og:image:height" content="600" />
          </>
        ) : null}
        <meta property="og:site_name" content={meta.siteName} />
        <link rel="canonical" href={meta.canonicalUrl} />
        {meta.faviconUrl ? (
          <link rel="shortcut icon" href={meta.faviconUrl} />
        ) : null}
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
      </Head>
      <style global jsx>{`
        html {
          --custom-font-family: ${props.font.family};
        }
      `}</style>
      {checkout.enabled ? (
        <CheckoutViewRouter
          {...props}
          playing={playing}
          setPlaying={setPlaying}
          checkout={checkout}
        />
      ) : (
        <LookbookViewRouter
          {...props}
          playing={playing}
          setPlaying={setPlaying}
        />
      )}
    </Size>
  );
}
